export const baseUrls = {
  messageHub: import.meta.env.VITE_MESSAGE_HUB || 'https://localhost:44390',
  supportApi: import.meta.env.VITE_SUPPORT_API || 'https://localhost:44395',
}
